import { Environment } from "../types/environment";

export const ENVIRONMENT: Environment = {
  MSAL: {
    clientId: "a673878a-b4d3-4c9d-bc5a-1626eedb47ad",
    tenantId: "89bf691e-28e2-4dbc-9709-02294a8c1bf5",
    scopes: ["api://d7d79311-d01d-45bb-9421-5370fe76c9dc/access", "User.Read"],
  },
  API: "https://app-ag-klop-klopback-api-dev.azurewebsites.net",
  TYPE: "ACC",
  INTERCEPT: [
    { url: "http://localhost:8080", match: "full", trigger: "default" },
    { url: "https://app-ag-klop-klopback-api-dev.azurewebsites.net", match: "full", trigger: "default" },
  ],
};
